import {GanttChartXAxis} from '@hconnect/ganttchart/src/modules/GanttChartXAxis'
import {Box, Stack} from '@mui/material'
import {useEffect, useRef, useState} from 'react'

import {HeatZoneSection} from '@kilnfeature/modules/heatZones/HeatZonesView/HeatZoneSection'
import {HeatZone} from '@kilnfeature/types'

type HeatZonesViewProps = {
  heatZones: HeatZone[]
  kilnLength: number
  hideXAxis?: boolean
  hideDetails?: boolean
  zoneHeight?: number
  maxWidth?: number
  width?: number
}

export const HeatZonesView = ({
  kilnLength,
  heatZones,
  hideXAxis,
  zoneHeight,
  hideDetails,
  maxWidth,
  width
}: HeatZonesViewProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [stepWidth, setStepWidth] = useState(width ? width / kilnLength : 0)

  useEffect(() => {
    const handleResize = () => {
      if (width) {
        setStepWidth(width / kilnLength)
      } else if (containerRef.current) {
        setStepWidth(containerRef.current.clientWidth / kilnLength)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [kilnLength, width])

  const canvasWidth = kilnLength * stepWidth

  return (
    <Box>
      <Box
        ref={containerRef}
        width={maxWidth ?? '100%'}
        borderRadius={1}
        overflow="hidden"
        data-test-id="heat_zones_sections"
      >
        <Stack direction={'row'}>
          {heatZones.map((zone, index) => {
            const width = (zone.end - zone.start) * stepWidth
            return (
              <HeatZoneSection
                zoneHeight={zoneHeight}
                key={`heatZone.${index}.section`}
                heatZone={zone}
                index={index}
                width={width}
                hideDetails={hideDetails}
              />
            )
          })}
        </Stack>
      </Box>
      {!hideXAxis && (
        <GanttChartXAxis
          canvasWidth={canvasWidth}
          kilnLength={kilnLength}
          stepWidth={stepWidth}
          yAxisLabelWidth={0}
          data-test-id="heat_zones_axis"
        />
      )}
    </Box>
  )
}
